$(document).ready(function() {

  // Create (non active) checkbox elements in forms
  $('.modal .form-check input[type="checkbox"]').on('change', function() {

    if ($('fieldset.service-type').length || $('fieldset.specialisms').length) {

      var theCheckboxId = $(this).attr('id');
      var theFieldsetClass = "";

      $(this).prop('name') == "serviceTypes" ? theFieldsetClass = "service-type" :  theFieldsetClass = "specialism";

      if($(this).prop('checked') == true) {
        $('<div class="card card-file card-file-uploaded '+theCheckboxId+'"><p class="pl-0">'+$(this).val()+'</p><span class="delete-button" data-toggle="modal" data-target="#deleteService"></span></div>').appendTo('fieldset.'+theFieldsetClass);
      }

      if($(this).prop("checked") == false) {
        $('.card-file.'+theCheckboxId).remove();
      }

      if ($('fieldset.service-type .card-file').length && $('fieldset.specialism .card-file').length) {
        $('.form-nav .bttn-submit').prop('disabled', false)
      }

      setupDeleteButtons();

    }

  });

});
